import { CasProfileApi, convertCasAddressToStoredAddress } from "@jti/rest-api";

import { TAGS } from "../common/tags";
import type { GetProfileQueryData, ProfileApiBuilder } from "../profileApiSlice.types";
import { handleProfileApiError } from "../utils/handleProfileApiError";

export const getProfileEndpoint = (builder: ProfileApiBuilder) => ({
  getProfile: builder.query<GetProfileQueryData, void>({
    queryFn: async () => {
      const casProfileApi = CasProfileApi.init();

      try {
        const response = await casProfileApi.getProfile();

        return {
          data: {
            ...response,
            addresses: response.addresses?.map((address) => convertCasAddressToStoredAddress(address)) ?? [],
          },
        };
      } catch (error: unknown) {
        return handleProfileApiError(error);
      }
    },
    providesTags: [TAGS.PROFILE],
  }),
});
